import { useEffect } from 'react';

const useScrollFade = (ref) => {
	useEffect(() => {
		const handleScroll = () => {
			const element = ref.current;

			if (!element) {
				return;
			}

			const rect = element.getBoundingClientRect();

			if (!rect) {
				return;
			}

			let distanceToTop = window.scrollY + rect.top;
			let elementHeight = element.offsetHeight;
			let scrollTop = document.documentElement.scrollTop;

			let opacity = 1;
			if (scrollTop > distanceToTop) {
				opacity = 1 - (scrollTop - distanceToTop) / elementHeight;
			}

			if (opacity >= 0) {
				element.style.opacity = opacity;
			}
		};

		window.addEventListener('scroll', handleScroll);

		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, [ref]);
};

export default useScrollFade;
